/** Shared public URL contracts for indexable anonymous HTML and payload links. */
import { z } from "zod";

const publicSlug = "[a-z0-9]+(?:-[a-z0-9]+)*";
const publicEntityHrefPattern = new RegExp(
  `^/(?:en|zh-cn)/(?:fandom|ships|creators)/${publicSlug}$`
);
const publicWorkHrefPattern = new RegExp(
  `^/(?:en|zh-cn)/works/${publicSlug}(?:/releases/${publicSlug}(?:/chapters/${publicSlug})?)?$`
);

export const publicDetailHrefSchema = z
  .string()
  .refine(
    (value) =>
      publicEntityHrefPattern.test(value) || publicWorkHrefPattern.test(value),
    "Expected a canonical public detail URL"
  );
